import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ContentfulImage from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';
import Slider from '../../../components/Slider/Slider';
import { Wrapper, SliderWrapper, ImageSlide, Disclaimers, DisclaimersInner } from './SeminarGallery.style';

const SeminarGallery = ({ photos, disclaimers, copy }) => (
  <Wrapper>
    <h5>{copy.previous_seminars_gallery || <Placeholder h="30px" w="300px" />}</h5>
    <SliderWrapper>
      {photos ? (
        <Slider
          dots
          keys={photos.map(photo => photo.assetId)}
          options={{
            duration: 400,
            easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
            loop: true,
          }}
        >
          {photos.map(photo => (
            <ImageSlide key={photo.assetId}>
              <ContentfulImage src={photo} options={{ size: 720, w: '100%', objectFit: 'cover' }} />
            </ImageSlide>
          ))}
        </Slider>
      ) : (
        <Placeholder h="400px" w="100%" />
      )}
    </SliderWrapper>
    <Disclaimers>
      <DisclaimersInner>
        {disclaimers.length > 0 && (
          <React.Fragment>
            <h6>{copy.disclaimers || <Placeholder w="100px" h="20px" />}</h6>
            {<ul>{disclaimers.map(disclaimer => <li key={disclaimer}>{disclaimer}</li>)}</ul>}
          </React.Fragment>
        )}
      </DisclaimersInner>
    </Disclaimers>
  </Wrapper>
);

SeminarGallery.defaultProps = {
  copy: {},
  disclaimers: [],
  photos: undefined,
};

SeminarGallery.propTypes = {
  copy: PropTypes.shape(),
  disclaimers: PropTypes.arrayOf(PropTypes.string),
  photos: PropTypes.arrayOf(PropTypes.shape()),
};

const mapState = state => ({
  copy: state.siteOptions.siteCopySeminarPage,
});

export default connect(mapState)(SeminarGallery);



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/SeminarGallery/SeminarGallery.js